export default __webpack_public_path__ + "static/media/0x9c49ba0212bb5db371e66b59d1565b7c06e4894e.93e032ad.webp";